import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { CoreService } from 'src/app/shared/services/core-service.service';
import { environment } from 'src/environments/environment';
import { RequestStatus } from '../interfaces/request-status.interface';
import { Observable, catchError, map, throwError } from 'rxjs';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root'
})
export class RequestStatusService {

  private _requestStatus  = signal<RequestStatus| any>('');
  private _requestStatusMultiple = signal<RequestStatus| any>('');
  public requestStatus$   = computed(() => this._requestStatus());
  public requestStatusFiltered$ = computed(() => this._requestStatusMultiple());
  private isFetchingStatus = false;

  private baseUrl: string = environment.baseUrlAuth;
  private http                    = inject( HttpClient );
  private _coreService            = inject( CoreService );
  private spinnerService          = inject(SpinnerService);

  initialize() {
    // this.getListRequestStatus().subscribe();
    // Cuando se crea una instancia del servicio, se llama al método privado para obtener los datos por primera vez
    const authToken = localStorage.getItem('token');
    if (authToken) {
      this.fetchRequestStatus();
    } else {
      console.error('No hay token de autenticación');
    }
   }

  // Método privado para obtener los datos del backend
  private fetchRequestStatus(force = false): void {
    if (this.isFetchingStatus) {
      return;
    }

    if (!force && this.hasStatusCached()) {
      return;
    }

    const apiUrl = `${this.baseUrl}/api/documentos/estados-solicitudes`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });
    this.isFetchingStatus = true;
    this.spinnerService.show();
    this.http.get<RequestStatus[]>(apiUrl, { headers }).pipe(
      catchError(err => {
        this._coreService.openErrorSnackbar(`Error al obtener la lista de estados de documentos: ${err.error.message}`, 'Ok');
        return throwError(() => err);
      })
    ).subscribe({
      next: (response: RequestStatus[]) => {
        this._requestStatus.set(response);
        // Filtrar la respuesta y guardarla en otra variable sin el último elemento
        const filteredResponse = response.slice(0, response.length - 1);
        this._requestStatusMultiple.set(filteredResponse);

        this.isFetchingStatus = false;
        this.spinnerService.hide();
      },
      error: (err: any) => {
        this.isFetchingStatus = false;
        this._coreService.openErrorSnackbar(`Error al obtener la lista de estados de documentos: ${err.error.message}`, 'Ok');
        console.error('Error al obtener la lista de estados de documentos:', err);
      },
      complete: () => {
        this.isFetchingStatus = false;
        this.spinnerService.hide();
      }
    });
  }

  // Método público para forzar una actualización de los datos
  public updateRequestStatus(): void {
    this.fetchRequestStatus(true);
  }

  private hasStatusCached(): boolean {
    const statusResponse = this._requestStatus();
    return Array.isArray(statusResponse);
  }


  getListRequestStatus(): Observable<any> {
    const apiUrl = `${this.baseUrl}/api/documentos/estados-solicitudes`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.get<RequestStatus>(apiUrl, { headers })
      .pipe(
        // tap((response: any) => console.log('response:', response)),
        map((response: RequestStatus) => response),
        catchError(err => {
          this._coreService.openErrorSnackbar(`Error al obtener la lista de estados de documentos: ${err.error.message}`, 'Ok');
          return throwError(() => err)
        }
        )
      );
  }

}
